<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong>
                        Fill Self Appraisal
                    </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row class="sub-row" justify="center" dense>
                <v-col cols="12" xs="12" sm="2" lg="2" md="12">
                    <p class="padding-bot"><b>Academic Year</b></p>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="aylist" item-text="ay" item-value="id" label="Academic Year" outlined @change="getData();" />
                </v-col>
            </v-row>
        </v-card>
        <apprisal-report v-if="show==true"></apprisal-report>
    </div>
    </template>
    
    <script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import GetSelfApprisalPerformanceMeasurementReport from './GetSelfApprisalPerformanceMeasurementReport'
    export default {
        components:{
      'apprisal-report':GetSelfApprisalPerformanceMeasurementReport,
    },
        data: () => ({
            show:false,
            upload_loader: false,
            all_data_list: [],
            loader: false,
            search: "",
            snackbar_msg: "",
            snackbar: false,
            color: "",
            aylist: [],
            ay: "",
            basepath: "",
            instructor_id:null,
            authority_id:null
        }),
        methods: {
            getData() {
            this.show = false
            this.loader = true
            const formData = {
                ay: this.ay,
            };
            axios
                .post("/FillSelfAppriasal/getDataSBPPS", formData)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        localStorage.setItem("setay", this.ay);
                        localStorage.setItem("setinst", res.data.instructor_id);
                        localStorage.setItem("authority", res.data.authority_id);
                        this.show = true
                        this.loader = false
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("#b71c1c", res.data.snackbar);
                        this.loader = false
                    } else {
                        //   window.console.log(res.data.msg);
                        this.showSnackbar("#b71c1c", "Something went wrong!");
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {});
        },
            // getData() {
            //     alert("getData")
            //     localStorage.setItem("setay", this.ay);
            //     localStorage.setItem("setinst", this.instructor_id);
            //     localStorage.setItem("authority", this.authority_id);
            // this.show = true
            // },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onLoad() {
                axios
                    .post("/FillSelfAppriasal/getData")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.aylist = res.data.aylist
                            this.instructor_id = res.data.instructor_id
                            this.authority_id = res.data.self_id
                            this.basepath = res.data.aws_path;
                            //this.ay = res.data.cay
                        } else {
                            //   window.console.log(res.data.msg);
                            this.showSnackbar("#b71c1c", "Something went wrong!");
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {});
            },
        },
        mounted() {
            this.onLoad();
        },
    };
    </script>
    
    <style scoped>
    .tc-title {
        background-image: linear-gradient(-90deg, #fff, blue);
        color: #fff;
        border-radius: 3px;
    }
    
    .table-head {
        background: #0f2027;
        /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027);
        /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027);
        /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        color: white !important;
    }
    
    .textcolor {
        color: darkblue;
        font-weight: bold;
    }
    
    td,
    th {
        border: 1px solid #ccc;
    }
    
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
    }
    
    td {
        font-weight: bold;
    }
    
    td {
        margin: 1rem !important;
        padding: 1rem !important;
    }
    
    @media (min-width: 320px) {
    
        td,
        th {
            display: table-cell !important;
        }
    
        td+td,
        th+th {
            width: auto;
        }
    }
    
    sub-row {
        border: 2px solid #424093;
        margin: 1rem;
        border-radius: 5px;
    }
    
    i {
        font-size: 20px !important;
    }
    
    .v-card__title {
        border: 1px solid #80808040;
        font-weight: bold;
        background-color: #424093;
        color: white;
        text-align: center;
        /* margin-top: 1.5rem; */
    }
    
    .card-border {
        border: 2px solid darkblue;
        border-radius: 10px;
        /* padding: 5px; */
        /* margin: 1rem !important; */
        width: auto;
    }
    
    .tx-bold {
        font-weight: bold;
        font-size: 14px;
        color: black;
    }
    
    i {
        font-size: 26px;
        cursor: pointer;
    }
    
    theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
        background-color: #424093 !important;
        color: white !important;
        margin-top: 2.35rem;
        border-radius: 20px;
    }
    
    /*.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined):hover {
        background-color: orange !important;
        color: black !important;
    } */
    
    @media only screen and (max-width: 600px) {}
    
    .imgs {
        border: 1px solid #ddd;
        border-radius: 4px;
        padding: 5px;
        width: 150px;
        cursor: zoom-in;
    }
    
    .imgs-preview {
        border: 1px solid #ddd;
        border-radius: 4px;
        padding: 5px;
        width: auto;
    }
    
    v-simple-table {
        border-collapse: collapse;
        border-spacing: 0;
        width: auto;
        border: 1px solid #ddd;
    }
    
    th {
        color: white;
        font-weight: bold;
        text-align: center !important;
    }
    
    td,
    th {
        padding: 6px;
        border: 1px solid #ccc;
        text-align: center;
    }
    
    @media all and (max-width: 900px) {
        .padding-bot {
            padding: 8px;
        }
    }
    
    @media all and (min-width: 1000px) {
        .padding-metting {
            padding-right: 22px;
        }
    }
    
    @media (min-width: 320px) and (max-width: 350px) {
        .padding-bot {
            font-size: 11.6px;
        }
    }
    
    @media (min-width: 1000px) and (max-width: 1050px) {
        .padding-bot {
            font-size: 9.6px;
        }
    }
    
    .slide {
        color: red;
        font-weight: bold;
        margin-left: 10px;
    }
    </style>
    